<template>
  <div>
    <a-input v-model="value" v-bind="$attrs">
      <div slot="addonAfter"
           style="cursor:pointer;"
           @click="chooseDirectory">
        <a-icon type="folder"/>
        选择
      </div>
    </a-input>
  </div>
</template>

<script>
import StateMixin from "./StateMixin";

export default {
  name: 'FolderPicker',
  mixins: [StateMixin],
  props: {
    SubDir: String,
  },
  methods: {
    async chooseDirectory() {
      let dir = await window.getDirectory();
      dir = dir.split("\\").join("/");
      let val = this.SubDir ? `${dir}/${this.SubDir}` : dir;
      this.value = val;
      this.$emit('change', val);
    }
  }
}
</script>
